import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectIsDraftTermsUpdated = (state: AppStateType, defaultValue = false): boolean =>
  state?.devtoolsLocale?.isDraftTermsUpdated || defaultValue;
